export default "__VITE_ASSET__eJ9nt0lO__"